import { DOCUMENT } from "@angular/common";
import { Component, ElementRef, HostListener, Inject, OnInit, ViewChild } from "@angular/core";

import { SearchService } from "app/layout/components/navbar/navbar-search/search.service";
import { menu } from "app/menu/menu";
import { CoreMenu } from "@core/types";
import { NavbarService } from "../navbar.service";
import { Subscription } from "rxjs";

@Component({
  selector: "app-navbar-search",
  templateUrl: "./navbar-search.component.html",
})
export class NavbarSearchComponent implements OnInit {
  public searchText = "";
  public openSearchRef = false;
  public activeIndex = 0;
  public apiData;
  public pages = [];
  public files = [];
  public contacts = [];
  public pageSearchLimit;
  private subscription: Subscription = new Subscription();

  @ViewChild("openSearch") private _inputElement: ElementRef;
  @ViewChild("pageList") private _pageListElement: ElementRef;

  @HostListener("keydown.escape") fn() {
    this.removeOverlay();
    this.openSearchRef = false;
    this.searchText = "";
  }
  @HostListener("document:click", ["$event"]) clickout(event) {
    if (event.target.className === "content-overlay") {
      this.removeOverlay();
      this.openSearchRef = false;
      this.searchText = "";
    }
  }

  constructor(
    @Inject(DOCUMENT) private document,
    public _searchService: SearchService,
    private navbarService: NavbarService
  ) {}

  nextActiveMatch() {
    this.activeIndex =
      this.activeIndex < this.pageSearchLimit - 1 ? ++this.activeIndex : this.activeIndex;
  }

  prevActiveMatch() {
    this.activeIndex = this.activeIndex > 0 ? --this.activeIndex : 0;
  }

  removeOverlay() {
    this.document.querySelector(".app-content").classList.remove("show-overlay");
  }

  autoSuggestion(event) {
    if (38 === event.keyCode) {
      return this.prevActiveMatch();
    }
    if (40 === event.keyCode) {
      return this.nextActiveMatch();
    }
    if (13 === event.keyCode) {
      let current_item = this._pageListElement.nativeElement.getElementsByClassName("current_item");
      current_item[0]?.children[0].click();
    }
  }

  toggleSearch() {
    this._searchService.onIsBookmarkOpenChange.next(false);
    this.removeOverlay();
    this.openSearchRef = !this.openSearchRef;
    this.activeIndex = 0;
    setTimeout(() => {
      this._inputElement.nativeElement.focus();
    });

    if (this.openSearchRef === false) {
      this.document.querySelector(".app-content").classList.remove("show-overlay");
      this.searchText = "";
    }
  }

  searchUpdate(event) {
    const val = event.target.value.toLowerCase();
    if (val !== "") {
      this.document.querySelector(".app-content").classList.add("show-overlay");
    } else {
      this.document.querySelector(".app-content").classList.remove("show-overlay");
    }
    this.autoSuggestion(event);
  }

  extractMenuItems(menuItems: CoreMenu[]): any[] {
    let result = [];

    const processMenuItem = (item, parentTitle = null) => {
      if (item.type === "item" && item.url) {
        result.push({
          title: parentTitle ? `${parentTitle} > ${item.title}` : item.title,
          icon: item.icon,
          link: item.url || "",
          role: item.role,
        });
      }

      if (item.children && item.children.length > 0) {
        const newParentTitle =
          item.type === "section"
            ? null
            : parentTitle
            ? `${parentTitle} > ${item.title}`
            : item.title;

        item.children.forEach((child) => {
          processMenuItem(child, newParentTitle);
        });
      }
    };

    menuItems.forEach((item) => {
      processMenuItem(item);
    });

    return result;
  }

  ngOnInit(): void {
    this.pages = this.extractMenuItems(menu);

    this.subscription.add(
      this.navbarService.searchOpen$.subscribe((isOpen) => {
        if (isOpen !== this.openSearchRef) {
          this.toggleSearch();
        }
      })
    );
  }

  ngOnDestroy(): void {
    // Désabonnement pour éviter les fuites de mémoire
    this.subscription.unsubscribe();
  }
}
